import {
    useCreateCompanyProcessMutation, 
    useUpdateCompanyProcessMutation, 
    useDeleteCompanyProcessMutation,
    useUpdateCompanyProcessStatusMutation 
} from "@companyProcess/services/companyProcessService";
import type { 
    CreateCompanyProcessPayload, 
    CreateCompanyProcessResult, 
    UpdateCompanyProcessPayload, 
    UpdateCompanyProcessResult, 
    DeleteCompanyProcessResult,
    UpdateCompanyProcessStatusPayload,
    UpdateCompanyProcessStatusResult
} from "@companyProcess/types/companyProcess";
import { err, ok } from "neverthrow";

const useCompanyProcess = () => {
    const [executeCreate, {isLoading: isLoadingCreateCompanyProcess}] = useCreateCompanyProcessMutation()
    const [executeUpdate, {isLoading: isLoadingUpdateCompanyProcess}] = useUpdateCompanyProcessMutation()
    const [executeDelete, {isLoading: isLoadingDeleteCompanyProcess}] = useDeleteCompanyProcessMutation()
    const [executeUpdateStatus, {isLoading: isLoadingUpdateCompanyProcessStatus}] = useUpdateCompanyProcessStatusMutation()

    const createCompanyProcess = async(values: CreateCompanyProcessPayload): CreateCompanyProcessResult => {
        return await executeCreate(values)
        .unwrap()
        .then(() => ok(true))
        .catch((error) => err(error))
    }

    const updateCompanyProcess = async(values: UpdateCompanyProcessPayload): UpdateCompanyProcessResult => {
        return await executeUpdate(values)
        .unwrap()
        .then(() => ok(true))
        .catch((error) => err(error))
    }

    const deleteCompanyProcess = async(id: number):DeleteCompanyProcessResult => {
        return await executeDelete(id)
        .unwrap()
        .then(() => ok(true))
        .catch((error) => err(error))
    }

    const updateCompanyProcessStatus = async(values: UpdateCompanyProcessStatusPayload): UpdateCompanyProcessStatusResult => {
        return await executeUpdateStatus(values)
        .unwrap()
        .then(() => ok(true))
        .catch((error) => err(error))
    }

    return{
        isLoadingCreateCompanyProcess,
        isLoadingUpdateCompanyProcess,
        isLoadingDeleteCompanyProcess,
        isLoadingUpdateCompanyProcessStatus,
        createCompanyProcess,
        updateCompanyProcess,
        deleteCompanyProcess,
        updateCompanyProcessStatus
    }
}

export default useCompanyProcess;
